import { memo } from "react";
import { motion } from "framer-motion";

interface ToggleSwitcherProps {
  isOn: boolean;
  onClick?: () => void;
  vertical?: boolean;
  className?: string;
}

const ToggleSwitcher = memo<ToggleSwitcherProps>(
  ({ isOn, onClick, vertical = false, className = "" }) => {
    const Tag = onClick ? "button" : "div";
    return (
      <Tag onClick={onClick} className={`flex-shrink-0 ${className}`}>
        <motion.div
          animate={{ backgroundColor: isOn ? "#283211" : "#300f10" }}
          transition={{ duration: 0.35 }}
          className={
            vertical
              ? "w-[21px] h-[34px] border-[3px] border-black/70 rounded-[5px] p-[1px] shadow-sm flex flex-col items-center"
              : "w-[34px] h-[21px] border-[3px] border-black/70 rounded-[5px] p-[1px] shadow-sm flex items-center"
          }
        >
          <motion.span
            layout
            animate={{
              ...(vertical
                ? { y: isOn ? "100%" : "0%" }
                : { x: isOn ? "100%" : "0%" }),
              backgroundColor: isOn ? "#C3FF1F" : "#FF1F1F",
              boxShadow: isOn
                ? "0 0 6px 2px #C3FF1F88"
                : "0 0 6px 2px #FF1F1F88",
            }}
            transition={{
              type: "spring",
              stiffness: 500,
              damping: 28,
              backgroundColor: { duration: 0.25 },
              boxShadow: { duration: 0.25 },
            }}
            className={
              vertical
                ? "block w-full h-[50%] rounded-[2px]"
                : "block w-[50%] h-full rounded-[2px]"
            }
          />
        </motion.div>
      </Tag>
    );
  },
);

ToggleSwitcher.displayName = "ToggleSwitcher";
export default ToggleSwitcher;
